import type { CustomFormData } from '../types/form.types';

export const transformFormDataForAPI = (formData: CustomFormData) => {
  return {
    height_feet: formData.heightFeet ? parseInt(formData.heightFeet, 10) : null,
    height_inch: formData.heightInch ? parseInt(formData.heightInch, 10) : null,
    weight: formData.weight ? parseFloat(formData.weight) : 0,
    weight_unit: formData.weightUnit || "lbs",
    neck_circumference: formData.neckCircumference ? parseFloat(formData.neckCircumference) : null,
    waist_circumference: formData.waistCircumference ? parseFloat(formData.waistCircumference) : null,

    tonsil_size: formData.tonsilSize,
    ahi: formData.ahi ? parseFloat(formData.ahi) : null,
    odi: formData.odi ? parseFloat(formData.odi) : null,
    rei: formData.rei ? parseFloat(formData.rei) : null,
    plmi: formData.plmi ? parseFloat(formData.plmi) : null,

    sleep_stage: formData.sleepStage || 0,
    mean_heart_rate: formData.meanHeartRate ? parseFloat(formData.meanHeartRate) : null,
    oxygen_saturation: formData.oxygenSaturation ? parseFloat(formData.oxygenSaturation) : null,
    arousal_index: formData.arousalIndex ? parseFloat(formData.arousalIndex) : null,
    respiratory_disturbance_index: formData.respiratoryDisturbanceIndex ? parseFloat(formData.respiratoryDisturbanceIndex) : null,
    sleep_position: formData.sleepPosition || 0,
    sleep_duration: formData.sleepDuration || 0,

    nocturia: formData.nocturia || 0,
    snoring: formData.snoring,
    witnessed_apnea: formData.witnessedApnea,
    breathing_stops: formData.breathingStops || 'No',
    morning_headaches: formData.morningHeadaches || 'No',
    daytime_fatigue: formData.daytimeFatigue || 0,
    morning_dry_mouth: formData.morningDryMouth || 'No',

    hypertension: formData.hypertension || 'No',
    diabetes: formData.diabetes || 'No',
    thyroid_function: formData.thyroidFunction,
    family_history: formData.familyHistory,

    smoking_status: formData.smokingStatus || 0,
    alcohol_consumption: formData.alcoholConsumption || 0,
    physical_activity: formData.physicalActivity || 0,

    receive_info: formData.receiveInfo || false,
  };
};

export const transformAPIResponseToFormData = (apiResponse: any): Partial<CustomFormData> => {
  return {
    heightFeet: apiResponse.height_feet != null ? String(apiResponse.height_feet) : null,
    heightInch: apiResponse.height_inch != null ? String(apiResponse.height_inch) : null,
    weight: apiResponse.weight != null ? String(apiResponse.weight) : null,
    weightUnit: apiResponse.weight_unit || "lbs",
    bmi: apiResponse.bmi || null,
    neckCircumference: apiResponse.neck_circumference?.toString() || null,
    waistCircumference: apiResponse.waist_circumference?.toString() || null,

    tonsilSize: apiResponse.tonsil_size,
    ahi: apiResponse.ahi?.toString() || null,
    odi: apiResponse.odi?.toString() || null,
    rei: apiResponse.rei?.toString() || null,
    plmi: apiResponse.plmi?.toString() || null,

    sleepStage: apiResponse.sleep_stage,
    meanHeartRate: apiResponse.mean_heart_rate?.toString() || null,
    oxygenSaturation: apiResponse.oxygen_saturation?.toString() || null,
    arousalIndex: apiResponse.arousal_index?.toString() || null,
    respiratoryDisturbanceIndex: apiResponse.respiratory_disturbance_index?.toString() || null,
    sleepPosition: apiResponse.sleep_position,
    sleepDuration: apiResponse.sleep_duration,

    nocturia: apiResponse.nocturia,
    snoring: apiResponse.snoring,
    witnessedApnea: apiResponse.witnessed_apnea,
    breathingStops: apiResponse.breathing_stops,
    morningHeadaches: apiResponse.morning_headaches,
    daytimeFatigue: apiResponse.daytime_fatigue,
    morningDryMouth: apiResponse.morning_dry_mouth,

    hypertension: apiResponse.hypertension,
    diabetes: apiResponse.diabetes,
    thyroidFunction: apiResponse.thyroid_function,
    familyHistory: apiResponse.family_history,

    smokingStatus: apiResponse.smoking_status,
    alcoholConsumption: apiResponse.alcohol_consumption,
    physicalActivity: apiResponse.physical_activity,

    riskScore: apiResponse.risk_score,
    riskLevel: apiResponse.risk_level,
    riskFactors: apiResponse.risk_factors || [],
    recommendations: apiResponse.recommendations || [],
    receiveInfo: apiResponse.receive_info || false,
  };
};
